

import { Button, CloseButton, Dialog, Portal, Text } from "@chakra-ui/react";

const LayerEditConfirmCancelDialog = ({ state, setForceToCancel }) => {
  return (
    <Dialog.Root
      lazyMount
      open={state[0]}
      onOpenChange={(e) => {
        state[1](e.open);
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title> Cancel Confirmation </Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Text>Do you want to discard changes?</Text>
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button
                colorPalette={"red"}
                onClick={() => {
                  setForceToCancel(true);
                }}
              >
                Cancel Editing
              </Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayerEditConfirmCancelDialog;
